// useOutsideClick.ts

import { useEffect } from "react";

function useOutsideClick(ref?: React.RefObject<HTMLElement> | null, callback?: () => void) {
    useEffect(() => {
        function handleClickOutside(event: MouseEvent) {
            if (ref?.current && !ref.current.contains(event.target as Node) && callback) {
                callback();
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [ref, callback]);
}

export { useOutsideClick };
